function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import { Component } from 'react';
import PropTypes from 'prop-types';
import shallowEqual from './utils/shallowCompare';

var Element = function (_Component) {
  _inherits(Element, _Component);

  function Element(props, context) {
    _classCallCheck(this, Element);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = {};


    _this.value = _this.getOriginalValue(props, context);
    return _this;
  }

  Element.prototype.componentDidMount = function componentDidMount() {
    var parent = this.getParent();
    // I am form
    if (!parent) {
      return;
    }

    parent.registerChild(this, this.props.name);
  };

  Element.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var sameChildren = nextProps.sameChildren;

    var form = this.getForm();

    if (sameChildren === true || typeof sameChildren === 'undefined' && form.props.sameChildren === true) {
      var sameProps = shallowEqual(this.props, nextProps, ['children']);
      if (!sameProps) {
        return true;
      }

      var sameState = shallowEqual(this.state, nextState, []);
      if (!sameState) {
        return true;
      }

      return false;
    }

    return true;
  };

  Element.prototype.componentWillUnmount = function componentWillUnmount() {
    var parent = this.getParent();
    // I am form
    if (!parent) {
      return;
    }

    parent.unregisterChild(this, this.props.name);
  };

  Element.prototype.getIndexes = function getIndexes() {
    return this.getParent().getIndexes();
  };

  Element.prototype.getTotals = function getTotals() {
    return this.getParent().getTotals();
  };

  Element.prototype.getOriginalValue = function getOriginalValue(props, context) {
    var name = props.name;
    var fieldset = context.fieldset;

    if (!fieldset) {
      return undefined;
    }

    return fieldset.getChildValue(name);
  };

  Element.prototype.getValue = function getValue() {
    return this.value;
  };

  Element.prototype.getParent = function getParent() {
    return this.context.fieldset;
  };

  Element.prototype.getPath = function getPath() {
    var name = this.props.name;

    return this.getPathByName(name);
  };

  Element.prototype.getPathByName = function getPathByName(name) {
    var parent = this.getParent();
    if (!parent) {
      return undefined;
    }

    return parent.buildPath(name);
  };

  Element.prototype.getForm = function getForm() {
    var parent = this.getParent();
    if (!parent) {
      return undefined;
    }

    return parent.getForm();
  };

  Element.prototype.setValue = function setValue(value) {
    var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
    var notifyChildren = arguments[2];
    var currentValue = this.value;

    if (currentValue === value) {
      return;
    }

    this.value = value;

    if (notifyChildren) {
      this.forceUpdate();
      return;
    }

    this.notifyParent(value, component);

    if (component === this) {
      this.forceUpdate();
    }
  };

  Element.prototype.replaceChildren = function replaceChildren(children) {
    return this.getParent().replaceChildren(children);
  };

  Element.prototype.originalValueChanged = function originalValueChanged() {
    var value = this.getOriginalValue(this.props, this.context);
    this.setValue(value, this, true);
  };

  Element.prototype.notifyParent = function notifyParent(value, component) {
    var name = this.props.name;

    var parent = this.getParent();

    // form has no parent
    if (parent) {
      parent.setChildValue(name, value, component);
    }
  };

  Element.prototype.render = function render() {
    return null;
  };

  return Element;
}(Component);

Element.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
Element.contextTypes = {
  fieldset: PropTypes.object.isRequired
};
export default Element;
//# sourceMappingURL=Element.js.map